import { useDialogStore } from '~/stores/dialog.ts';

export default defineNuxtRouteMiddleware(() => {
  const nuxtApp = useNuxtApp();
  if (!nuxtApp.$pinia) {
    return;
  }
  const dialogStore = useDialogStore();
  if (dialogStore.componentName) {
    dialogStore.showDialog = false;
  }
});
